<div *ngIf="loading" class="loading-text">
    <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
  </div>

  <div *ngIf="!loading">
<app-sub-header [pageTitle]="'FinishVoucher' | translate"></app-sub-header>

<div class="padded-container">
    <div *ngIf="odometerResponse?.odometerValue">
        <dx-form [formData]="odometerResponse" [colCount]="1">
            <dxi-item itemType="group" caption="{{ 'OdometerLastValue' | translate }}">
                <dxi-item>
                    <dx-number-box [(value)]="startOdometerValue" [showSpinButtons]="true" [min]="odometerResponse?.odometerValue?.odometerEndVal"></dx-number-box>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="{{ 'EndTime' | translate }}">
                <dxi-item>
                    <div class="row">
                        <div class="col-6">
                            <dx-select-box [(value)]="startHours" [items]="hours"></dx-select-box>
                        </div>
                        <div class="col-6">
                            <dx-select-box [(value)]="startMinutes" [items]="minutes"></dx-select-box>
                        </div>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="{{ 'Date' | translate }}">
                <dxi-item>
                    <dx-date-box [(value)]="chosenDate" displayFormat="dd/MM/yyyy" dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"></dx-date-box>
                </dxi-item>
            </dxi-item>
            <dxi-item>
                <div class="button-container">
                    <dx-button class="half-width-button" type="default"
                        [text]="isMobile ? '<' : ('PreviousDay' | translate)" 
                        (onClick)="dayBack()">
                    </dx-button>
                    <dx-button class="half-width-button" type="default" 
                        [text]="isMobile ? '>' : ('NextDay' | translate)" 
                        (onClick)="dayForward()">
                    </dx-button>
                </div>
            </dxi-item>

            <dxi-item itemType="group" caption="{{ 'Comment' | translate }}">
                <dxi-item>
                  <dx-text-area [(ngModel)]="comment" [autoResizeEnabled]="true"></dx-text-area>
                </dxi-item>
              </dxi-item>

        </dx-form>
        <dx-button
            class="full-width-button"
            text="{{ 'Save' | translate }}"
            type="default"
            (onClick)="finishVoucher()"
            [disabled]="isButtonDisabled">
        </dx-button>
        <dx-button
            class="full-width-button"
            text="{{ 'Back' | translate }}"
            type="default"
            (onClick)="navigateToVoucher()">
        </dx-button>
    </div>
</div>

    <dx-popup
  [(visible)]="showPopup"
  [width]="isMobile ? '100%' : '60%'"
    [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile"
  [showTitle]="true"
  [hideOnOutsideClick]="false" [showCloseButton]="true"
  title="{{ 'Notification' | translate }}"
  (onHiding)="closePopup()">
  <div>{{ popupMessage }}</div>
</dx-popup>
</div>